exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.checkout-warning[data-v-12155c74] {\n  margin: 1em;\n  font-weight: bold;\n  font-size: 1.2em;\n  text-align: center;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/checkout/EmptyCart.vue"],"names":[],"mappings":";AAAA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CAAE","file":"EmptyCart.vue","sourcesContent":[".checkout-warning {\n  margin: 1em;\n  font-weight: bold;\n  font-size: 1.2em;\n  text-align: center; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12155c74","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/checkout/EmptyCart.vue
// module id = 9Ic9
// module chunks = 18